import { setCookie } from 'src/functions/cookies';
import { ECookie } from './useCookies.enums';

const deleteGoogleAnalyticsCookies = () => {
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i];
		if (cookie.includes('_ga') || cookie.includes('_gid') || cookie.includes('_gat')) {
			const cookieParts = cookie.trim().split('=');
			const cookieName = cookieParts[0];
			document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		}
	}
};

const deleteMouseflowCookies = () => {
	let cookies = document.cookie.split(';');

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i];
		while (cookie.charAt(0) == ' ') {
			cookie = cookie.substring(1);
		}
		if (cookie.indexOf('_mf') == 0) {
			const cookieName = cookie.split('=')[0];
			document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
		}
	}
};

function _isReloadNeeded(types: ECookie[], savedTypes?: ECookie[]): boolean {
	let result = false;

	if (!savedTypes) {
		result = false;
	} else if (types.length !== savedTypes.length) {
		result = true;
	} else {
		// check if all values are the same
		result = !types.every((type) => savedTypes.includes(type));
	}

	setCookie(ECookie.isReloadNeeded, result, 10);

	return result;
}

export { deleteGoogleAnalyticsCookies, deleteMouseflowCookies, _isReloadNeeded };
